import React, { useEffect, useState } from 'react';
import { ShoppingCart } from 'lucide-react';

/**
 * Barra de compra fixa no celular. Aparece depois do topo da página e some quando a loja está na tela
 * (para não atrapalhar a escolha do produto). Deixa espaço à direita para o botão do WhatsApp.
 * Calcula pela posição dos blocos a cada rolagem (simples e confiável, com a loja carregando em partes).
 */
const MobileBuyBar = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let last = 0;
    const check = () => {
      last = Date.now();
      const hero = document.getElementById('top');
      const shop = document.getElementById('loja');
      const vh = window.innerHeight;
      const pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > vh;
      let shopOnScreen = false;
      if (shop) {
        const r = shop.getBoundingClientRect();
        shopOnScreen = r.top < vh * 0.6 && r.bottom > vh * 0.2;
      }
      setShow(pastHero && !shopOnScreen);
    };
    const onScroll = () => { if (Date.now() - last > 80) check(); }; // sem requestAnimationFrame: funciona também em janela sem foco
    window.addEventListener('scroll', onScroll, { passive: true, capture: true }); // capture: pega a rolagem de qualquer contêiner
    window.addEventListener('resize', onScroll);
    const timer = setInterval(onScroll, 700); // garante o estado certo enquanto as seções carregam
    check();
    return () => {
      window.removeEventListener('scroll', onScroll, true);
      window.removeEventListener('resize', onScroll);
      clearInterval(timer);
    };
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-4 left-4 right-24 z-40 transition-all duration-300 ${show ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0 pointer-events-none'}`}
      aria-hidden={!show}
    >
      <a href="#loja" tabIndex={show ? 0 : -1} className="pp-btn-gradient flex items-center justify-center gap-2 w-full py-3.5 rounded-full font-semibold shadow-[0_12px_30px_-8px_rgba(47,229,150,0.6)]">
        <ShoppingCart className="w-4 h-4" />Escolher meu cartão
      </a>
    </div>
  );
};

export default MobileBuyBar;
